export default __webpack_public_path__ + "static/media/green.8800cdd8.svg";